import * as React from 'react' ;
import { Button } from 'antd';
import '../../css/ErrorPage.scss';

export default class UnAuthorized extends React.Component<{}, {}> {
    render() {
        return (
            <div className="ErrorPage"> 
                <div className="errorNum"> 401 </div>
                <div> Unauthorized:</div> 
                <div>Authentication failed trying to access the</div> 
                <div>requested page</div> 
                <Button className="homeBtn" type="primary"> Go Home </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/errorPages/unauthorized.tsx